import { gql } from '@apollo/client';
export const blogArticleFragment = gql `
  fragment articleFields on ArticleEntity {
    thumbnail
    id
    createdAt
    isFeatured
    publishDate
    readingTime
    slug
    updatedAt
    status
  }
`;
//# sourceMappingURL=blog.js.map